import angular = require('angular');

export class TiposDocumentosRequeridosService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];
    public entities: any = [];
    public loaded: any = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: any = {
        to_load: 3,
        busy: false,
        finished: false,
    };
    public loading_deferred: any = null;
    public filter: any = '';

    constructor(public $http: angular.IHttpService, public nsjRouting: any, public $rootScope: angular.IScope, public $q: angular.IQService) {

    }

    reload () {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = 3;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search (filter: any) {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;
            Object.keys(this.filters).forEach((k: any) => { delete this.filters[k]; });
            for (var fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    var filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load (constructors: any, offset: any, filter: any) {
        /* Solução temporária para contornar o problema do mda-ui-select*/
        if (constructors.status) {
            if (constructors.status.toString().length === 1) {
                constructors.status = '0' + constructors.status;
            }
        }
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: any, reject: any) => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('meurh_tiposdocumentosrequeridos_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });

        });

    }

    loadByConstructors(constructors: any, offset: any = {}, filter: any = '') {
        const constructorsRequest = angular.copy(constructors);

        if (constructorsRequest.status) {
            if (constructorsRequest.status.toString().length === 1) {
                constructorsRequest.status = '0' + constructorsRequest.status;
            }
        }

        return this.$q((resolve: any, reject: any) => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate(
                    'meurh_tiposdocumentosrequeridos_index',
                    angular.extend({}, constructorsRequest, { 'offset': offset, 'filter': filter }),
                    true
                )
            })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });
        });
    }

    load () {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any) => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                        this.after['tipodocumentorequerido'] = this.entities[this.entities.length - 1]['tipodocumentorequerido'];
                    }
                    if (data.length < 50) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_list_finished', this.entities);
                    } else {
                        this.loadParams.finished = false;
                    }
                    this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_list_loaded', this.entities);
                    this.loaded = true;

                    this.loadParams.to_load--;
                })
                .catch((error: any) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                });
        }

        return this.entities;
    }

    async load_configuracoes () {
        if (!this.loadParams.busy && !this.loadParams.finished) {
            this.loadParams.busy = true;

            await this._load_configuracoes(this.constructors, this.after, this.filter)
                .then((data: any) => {
                    this.entities = data;
                    this.loadParams.finished = true;
                    this.loaded = true;
                    this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_list_finished', this.entities);
                })
                .catch((error: any) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                });
        }

        return this.entities;
    }

    _load_configuracoes (constructors: any, offset: any, filter: any) {
        /* Solução temporária para contornar o problema do mda-ui-select*/
        if (constructors.status) {
            if (constructors.status.toString().length === 1) {
                constructors.status = '0' + constructors.status;
            }
        }
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: any, reject: any) => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('meurh_tiposdocumentosrequeridos_configuracoes', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });

        });

    }

    loadMore () {
        this.loadParams.to_load = 3;
        this.load();
    }

    find (identifier: any) {
        for (var i in this.entities) {
            if (this.entities[i]['tipodocumentorequerido'] === identifier) {
                return this.entities[i];
            }
        }
        return null;
    }

    _save (entity: any, autosave: any) {
        var method, url;
        if (entity['tipodocumentorequerido']) {
            method = 'PUT';
            url = this.nsjRouting.generate('meurh_tiposdocumentosrequeridos_put', { 'id': entity['tipodocumentorequerido'] }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('meurh_tiposdocumentosrequeridos_create', angular.extend(this.constructors), true);
        }
        if (!autosave) {
            autosave = false;
            entity['$$__submitting'] = true;
        }
        var data = angular.copy(entity);
        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }
        this.loading_deferred = this.$q.defer();
        return this.$http({
            method: method,
            url: url,
            data: data,
            timeout: this.loading_deferred.promise
        })
            .finally(() => {
                if (!autosave) {
                    entity['$$__submitting'] = false;
                }
            });
    }

    save (entity: any, autosave: any) {

        this._save(entity, autosave)
            .then((response: any) => {
                if (response.data.tipodocumentorequerido) {
                    entity['tipodocumentorequerido'] = response.data.tipodocumentorequerido;
                }
                entity['$$_saved'] = true;
                this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            });
    }

    _save_configuracoes (entities: any, autosave: any) {
        var method, url;
        method = 'POST';
        url = this.nsjRouting.generate('meurh_tiposdocumentosrequeridos_create_configuracoes', angular.extend(this.constructors), true);
        if (!autosave) {
            autosave = false;
            entities['$$__submitting'] = true;
        }
        var data = angular.copy(entities);
        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }
        this.loading_deferred = this.$q.defer();
        return this.$http({
            method: method,
            url: url,
            data: data,
            timeout: this.loading_deferred.promise
        })
        .finally(() => {
            if (!autosave) {
                entities['$$__submitting'] = false;
            }
        });
    }

    save_configuracoes (entities: any, autosave: any) {
        this.loadParams.busy = true;
        this._save_configuracoes(entities, autosave)
            .then((response: any) => {
                if (response.data.tipodocumentorequerido) {
                    entities['tipodocumentorequerido'] = response.data.tipodocumentorequerido;
                }
                entities['$$_saved'] = true;
                this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_submitted', {
                    entity: entities,
                    response: response,
                    autosave: autosave
                });

                this.loadParams.busy = false;
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_submit_error', {
                    entity: entities,
                    response: response,
                    autosave: autosave
                });

                this.loadParams.busy = false;
            });
    }

    get (identifier: any) {
        this.loading_deferred = this.$q.defer();
        this.loadParams.busy = true;
        return this.$q((resolve: any, reject: any) => {
            this.$http
                .get(this.nsjRouting.generate('meurh_tiposdocumentosrequeridos_get', { 'id': identifier }, true),
                    { timeout: this.loading_deferred.promise })
                .then((response: any) => {
                    this.$rootScope.$broadcast('meurh_tiposdocumentosrequeridos_loaded', response.data);
                    this.loadParams.busy = false;
                    resolve(response.data);
                })
                .catch((response: any) => {
                    this.loadParams.busy = false;
                    reject(response);
                });
        });
    }
}
